import { BaseRegisterComponent } from '../../../../../../coverpath-common/angular/components/login-container/register/base-register.component';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ValidationService } from '../../../../../../coverpath-common/angular/services/validation/validation.service';
import { LoginService } from '../../../services/login/login.service';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { FormService } from '../../../../../../coverpath-common/angular/services/form/form.service';

@Component({
  moduleId: module.id,
  selector: 'register',
  templateUrl: './register.component.html',
})
export class RegisterComponent extends BaseRegisterComponent implements OnInit {
  @Output() triggerTFAComponent = new EventEmitter<boolean>();

  constructor(
    private amorphicServiceInj: AmorphicService,
    private validationServiceInj: ValidationService,
    private loginServiceInj: LoginService,
    private routerInj: Router,
    private formServiceInj: FormService
  ) {
    super(amorphicServiceInj, validationServiceInj, loginServiceInj, routerInj, formServiceInj);
  }

  ngOnInit(): void {
    this.buttonDisabled = true;
    this.isLoading = false;

    // if (
    //   !this.controller.customer.application ||
    //   !this.controller.customer.application.primaryPolicy ||
    //   !this.controller.customer.application.primaryPolicy.servicingAgent
    // ) {
    //   this.routerInj.navigate(['help']);
    // }
  }

  public async register(noValidate?: boolean): Promise<void> {
    if (!noValidate && !this.validate()) {
      return;
    }

    this.isLoading = true;

    this.loginServiceInj
      .accountExists()
      .then(() => {
        return this.loginServiceInj.needTFACheck();
      })
      .then(() => {
        return this.loginServiceInj.register();
      })
      .then((success) => {
        // Reprocess the invite now that we're logged in and this will reload the full object
        // hierarchy, allowing us to continue on properly with anything that would need that data
        this.controller.inviteController.reprocessInvite().then(() => {
          CoverpathUtils.dataLayerPush({
            event: 'gtm-event-client_applied',
            eventValue: `term | ${this.amorphicServiceInj.controller.customer.primaryQuote.term}`,
          });
          this.controller.cpFinalizeRegistration();
          this.routerInj.navigate(['application-form']);
        });
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.code === 'tfa_required') {
          this.requireTFAComponent();
          return;
        } else if (error.code === 'account_exists') {
          this.errorMessage = 'Account already exists with this email.';
          return;
        } else if (error.code === 'create_customer_failed') {
          this.errorMessage = 'Failed to create customer.';
          return;
        } else if (error.code === 'draft_in_progress') {
          this.errorMessage =
            'Your advisor is working on your application and will provide you with a link when it is ready.';
          return;
        }
      });
  }

  requireTFAComponent(): void {
    this.triggerTFAComponent.emit();
  }
}
